import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import useApiV2, {
  CINCO_MINUTOS,
  repetirSoErroDeServidor,
} from "../utils/useApiV2";

export default function useHomeGoalsV2({
  branchIds,
  start,
  end,
  tipo,
  enabled = true,
}) {
  const { getGoalMetrics } = useApiV2();
  const { user } = useAuth();

  return useQuery({
    queryKey: [
      "homeGoalsV2",
      user?.user_id ?? null,
      branchIds,
      start,
      end,
      tipo,
    ],
    queryFn: () =>
      getGoalMetrics({
        branch_id: branchIds,
        start,
        end,
        tipo,
        group_by: "day",
        incluir_hoje: "auto",
      }),
    enabled: Boolean(enabled && branchIds?.length && start && end),
    staleTime: CINCO_MINUTOS,
    retry: repetirSoErroDeServidor,
  });
}
